import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  BuildingOfficeIcon,
  PhoneIcon,
  EnvelopeIcon,
  ClockIcon,
  ArrowRightIcon
} from '@heroicons/react/24/outline';
import { useClientStore } from '../store/clientStore';

export function Clients() {
  const { clients } = useClientStore();

  return (
    <div className="space-y-6">
      <div className="bg-gray-800 rounded-lg p-6">
        <h1 className="text-2xl font-bold text-white mb-2">Clients</h1>
        <p className="text-gray-400">Manage and view all client relationships</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {clients.map((client) => (
          <div key={client.id} className="bg-gray-800 rounded-lg p-6 flex flex-col">
            <div className="flex items-center gap-4 mb-4">
              <div className="text-4xl">{client.logo}</div>
              <div>
                <h3 className="text-lg font-medium text-white">{client.name}</h3>
                <p className="text-gray-400 mb-4">{client.industry}</p>
              </div>
            </div>

            <div className="space-y-3 mb-6">
              <div className="flex items-center text-gray-300">
                <BuildingOfficeIcon className="h-5 w-5 text-gray-400 mr-2" />
                {client.contactName}
              </div>
              <div className="flex items-center text-gray-300">
                <EnvelopeIcon className="h-5 w-5 text-gray-400 mr-2" />
                <span className="truncate max-w-[200px]">{client.contactEmail}</span>
              </div>
              <div className="flex items-center text-gray-300">
                <PhoneIcon className="h-5 w-5 text-gray-400 mr-2" />
                {client.contactPhone}
              </div>
              <div className="flex items-center text-gray-300">
                <ClockIcon className="h-5 w-5 text-gray-400 mr-2" />
                Payment Terms: {client.paymentTerms}
              </div>
            </div>

            <div className="mt-auto pt-4">
              <Link
                to={`/clients/${client.id}`}
                className="inline-flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors w-full justify-center"
              >
                View Details
                <ArrowRightIcon className="ml-2 h-4 w-4" />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}